global.logger = console;

import { A11yModule } from '@angular/cdk/a11y';
import { CDK_CONNECTED_OVERLAY_DEFAULT_CONFIG, OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProfiling, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { FormbirdServicesModule } from '@formbird/services';
import { AngularJSWrapperService } from '@services/angular-js-wrapper/angular-js-wrapper.service';
import { CacheLoadService } from '@services/cache-load.service';
import { CustomCSSService } from '@services/custom-css.service';
import { CustomElementService } from '@services/custom-elements/custom-element.service';
import { NewDocumentService } from '@services/document/new-document.service';
import { ImageGalleryService } from '@services/image-gallery.service';
import { ImageLinkService } from '@services/image-link.service';
import { InitialisationService } from '@services/initialisation.service';
import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import { AuthInterceptorService } from '@services/interceptor/auth-interceptor.service';
import { GatewayErrorInterceptorService } from '@services/interceptor/gateway-error-interceptor.service';
import { KeyboardShortcutService } from '@services/keyboard-shortcut.service';
import { ListenServiceWorkerService } from '@services/listen-service-worker';
import { DocumentModalService } from '@services/modal/document-modal.service';
import { ModalService } from '@services/modal/modal.service';
import { StateChangeService } from '@services/state-change/state-change.service';
import { LightboxModule } from 'ngx-lightbox';
import { routes } from './app-routing/app.routes';
import { AppComponent } from './app/components/app.component';
import { CanDeactivateGuard } from './app/guards/can-deactivate.guard';
import { FormbirdCommonModule } from './app/modules/common/formbird-common.module';
import { TopBarModule } from './app/modules/top-bar/top-bar.module';
import { DocumentListService } from './app/services/document/document-list.service';

// enable profiling for angular. This is a noop in production mode
enableProfiling();

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom(FormsModule, LightboxModule, ReactiveFormsModule, BrowserModule, A11yModule, PortalModule, ScrollingModule, CdkStepperModule, CdkTableModule, CdkTreeModule, FormbirdServicesModule, FormbirdCommonModule, TopBarModule),
    // Popover-based overlays (CDK default in recent versions) can misposition mat-select and
    // similar connected overlays; use classic DOM positioning for correct anchor alignment.
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false }
    },
    {
      provide: CDK_CONNECTED_OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false }
    },
    provideRouter(routes, withPreloading(PreloadAllModules)),
    AngularJSWrapperService,
    CustomElementService,
    FormbirdInjectorService,
    ModalService,
    CanDeactivateGuard,
    // turn off http throttling until issue with errors on save, in https://mantis.formbird.com/view.php?id=14769#c55039 ,is solved
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: HttpRequestThrottleInterceptor,
    //   multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GatewayErrorInterceptorService,
      multi: true
    },
    ImageLinkService,
    ImageGalleryService,
    DocumentListService,
    NewDocumentService,
    Location,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    CacheLoadService,
    InitialisationService,
    CustomCSSService,
    KeyboardShortcutService,
    DocumentModalService,
    StateChangeService,
    ListenServiceWorkerService,
    provideHttpClient(withInterceptorsFromDi())
  ]
});
